import React, { Suspense, useState } from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import { Switch, Router } from "react-router-dom";
import { Provider } from "react-redux";
// import store from './store/store';
import { store } from "./redux/store/index";
import PrivateRoute from "./routes/privateRoute";
import PublicRoute from "./routes/publicRoute";
import { ROUTE } from "./routes/routes";
import Layout from "./containers/layout";
import Loader from "./utility/widgets/loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/scss/index.scss";
// To enable isRemember Need to logged out
import Authorization from "./utility/authorization";
import AppProvider from "./containers/context";

import history from "./history";

import { useEffect } from 'react';
import { invokeAkanaDemoService, invokePostServiceLogin,invokeGetAuthService,invokePostAuthService } from "./utility/base/service";
import { apiURL } from "./utility/base/utils/config";
import Cookies from "js-cookie";
import { clearLocalStorageData, setLocalStorageData, getLocalStorageData } from "./utility/base/localStore";
import { Alert } from "./utility/widgets/toaster";
import { ADMIN_ROLE } from "./utility/constant";
import { ErrorMsg, getSOHIdsAndCode } from "./utility/helper";

// Localization imports
import { IntlProvider } from "react-intl";
import flatten from "flat";
import messages_en from "./lang/en.json";
import messages_es from "./lang/es.json";
import messages_fr from "./lang/fr.json";

// MSAL imports
import { PublicClientApplication, EventType, EventMessage, AuthenticationResult } from "@azure/msal-browser";
import { msalConfig } from "./utility/base/utils/authConfig";
import { MsalProvider } from "@azure/msal-react";

export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance["browserStorage"].clear();

// Account selection logic is app dependent. Adjust as needed for different use cases.
const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

// Localization country code
const messages: any = {
  en: messages_en,
  es: messages_es,
  fr: messages_fr,
};

/**
 * Create the routes dynamically
 *
 * @return route component
 */
const setRoutes = (currentLocale: any, handleChange: any) => {
  const routes = ROUTE;
  return routes.map((route, index) =>
    route.private ? (
      <PrivateRoute
        key={index}
        path={route.path}
        meta={route.meta}
        exact={route.exact}
        component={route.component}
        role={route.role}
      />
    ) : (
      <PublicRoute
        key={index}
        path={route.path}
        meta={route.meta}
        exact={route.exact}
        component={route.component}
        currentLocale={currentLocale}
        handleChange={handleChange}
      />
    )
  );
};

/**
 * To handle remember me options(close brower tab or browser)
 * 
 */
function isRemember() {
  if (!sessionStorage.userLoggedIn) {
    if (!Authorization.isRemember()) Authorization.logOut();
  }
}
isRemember();

const App = () => {

  // Function to clear complete cache data
  const clearCacheData = () => {
    caches.keys().then((names) => {
      names.forEach((name) => {
        caches.delete(name);
      });
    });
  };
  clearCacheData()

  async function sTokenRetrive() {
      //Get authorize token
      await invokeAkanaDemoService()
        .then((response: any) => {})
        .catch((error: any) => {
          console.log(error, "error");
      });

      await silentLogin();

  }

  async function silentLogin() {
    try {
      let sso: any = getLocalStorageData("ssoInfo");
      let ssoInfomation = JSON.parse(sso);
      const data = {
        username: ssoInfomation.cwid,
        email: ssoInfomation.email,
        region: "R1",
      };

      // const data = {
      //   username: "EIOJQ",
      //   email: "dhanasekaran.b.ext@bayer.com",
      //   region: "R1",
      // };

      // //Get authorize token
      // await invokeAkanaDemoService()
      //   .then((response: any) => {})
      //   .catch((error: any) => {
      //     console.log(error, "error");
      // });

      const { login } = apiURL;
      invokePostServiceLogin(login, data)
        .then(async (response: any) => {
          if (response?.body?.length && !response?.body[0].ispasswordavail) {
            await Authorization.login(response.body);
            // The session continues with the last accessed profile, so the template must be loaded for that country
            const activeAP = response?.body.filter((ap: any) => Object.keys(ap?.lastaccessprofile || {})?.length > 1);
            const activeUser = activeAP?.length ? activeAP[0] : response?.body[0];
            Cookies.set("userData", JSON.stringify(activeUser), {
              expires: 7,
            });
            getLocationHierachyOrder(activeUser?.countrycode);
            const isAdmin = response?.body?.length === 1 && activeUser?.rolename === "ADMIN" ? true : false;
            if (isAdmin) {
              setLocalStorageData("userData", JSON.stringify(activeUser));
              history.push("/dashboard");
            } else {
              checkSOHRole(response?.body);
            }
          }
        })
        .catch((error: any) => {
          console.log(error, "error");
          Alert("info", error.message);
        })
        .catch((error: any) => {
          console.log(error, "error");
          Alert("info", error.message);
        });

    } catch (error: any) {
      console.error(error);
    }
  }


  /**
   * To get the dev config list
   */
 const getLocationHierachyOrder = (countrycode: string) => {
    const { getTemplateData } = apiURL;
    let data = {
      countryCode: countrycode,
    };
    invokeGetAuthService(getTemplateData, data).then((response: any) => {
      if (response?.body?.length > 0) {
        setLocalStorageData("countryInfo", JSON.stringify(response.body[0]));
        const scanPoint = response.body[0]?.scanpointallocationdefdatanew;
        const currencyCode = response.body[0]?.currencycode;
        setLocalStorageData("currencycode", currencyCode);
        const orderHistory = scanPoint.filter(
          (val: any) => val.allowedscantypes === "S2F_ADVISOR" || val.allowedscantypes === "D_S2F_ADVISOR"
        );
        //If advisor type is not available after hidden order histroy management(etc:Dashboard and Sidebar screen)
        if (!orderHistory?.length) {
          setLocalStorageData("isOrderHistory", true);
        }
        const isReturnsDataAvailable = response.body[0]?.returntransactiondefnition?.length;
        let returnsLength: any = isReturnsDataAvailable > 0 ? "true" : "false";
        setLocalStorageData("isReturnsDataAvailable", returnsLength);
      }
    });
  };

  /**
   * Check Three levels of SOH(lastaccessprofile) in logged user response
   * @param loggedUserData
   */
  const checkSOHRole = (loggedUserData: any[]) => {
    if (loggedUserData?.length) {
      const activeAccessProfile = loggedUserData[0].lastaccessprofile;
      if (activeAccessProfile && Object.keys(activeAccessProfile)?.length) {
        //Pass second argument is true,if true restrict api call
        checkSOHLevelOneArray(loggedUserData, true);
        loggedUserData.forEach((user: any) => {
          if (user.countrycode === activeAccessProfile.countrycode) {
            if (user?.rolename === ADMIN_ROLE) {
              const userData = { ...user };
              setLocalStorageData("userData", JSON.stringify(userData));
              history.push("/dashboard");
            } else {
              const sohProfile = user?.sohProfilesByCountry?.[0]?.sohprofiles;
              if (sohProfile?.length) {
                let isRole: any;
                const isProfile = sohProfile.find(
                  (pro: any) => pro.saleshiertypecode === activeAccessProfile.saleshiertypecode
                );
                const sohRole = isProfile?.sohroles;
                if (isProfile && sohRole?.length) {
                  isRole = sohRole.find((pro: any) => pro.saleshierrolecode === activeAccessProfile.saleshierrolecode);
                }

                // If lastaccessprofile data is matching for logged user response then redirect to the dashboard page
                if (isProfile && Object.keys(isProfile)?.length && isRole && Object.keys(isRole)?.length) {
                  const lowestSOHLevel = isRole?.lowestsohlevel;
                  const { sohids, sohcodes } = getSOHIdsAndCode(lowestSOHLevel);
                  const userData = { ...user, features: isRole?.features, sohids, sohcodes };
                  setLocalStorageData("userData", JSON.stringify(userData));
                  history.push("/dashboard");
                } else {
                  //If lastaccessprofile data is mismatched after redirect the soh popup page(home)
                  history.push("/home");
                }
                //Call soh level lookup
                let obj: any = getLocalStorageData("userData");
                let userData = JSON.parse(obj);
                let saleshiertypecode =
                  userData?.lastaccessprofile &&
                  Object.keys(userData?.lastaccessprofile)?.length > 0 &&
                  userData?.lastaccessprofile?.saleshiertypecode;
                let saleshierrolecode = userData?.lastaccessprofile?.saleshierrolecode;
                let sohObj = {
                  countrycode: userData?.countrycode,
                  saleshiertypecode: saleshiertypecode,
                  rolecode: saleshierrolecode,
                  userid: userData?.username,
                  sohids: userData?.sohids,
                };
                getSOHLookup(sohObj);
              }
            }
          }
        });
      } else {
        checkSOHLevelOneArray(loggedUserData);
      }
    }
  };
  
   // To get SOH levels
   const getSOHLookup = (sohObj: any) => {
      const { getSohDetails } = apiURL.soh;
      invokeGetAuthService(getSohDetails, sohObj)
        .then(async (response: any) => {
          setLocalStorageData("sohLookupDetails", JSON.stringify(response?.data));
        })
        .catch((error: any) => {});
    };

    /**
     * Check one option is exist on all three levesl of soh
     * @param loggedUserSOH
     */
    const checkSOHLevelOneArray = (loggedUserSOH: any[], cancelAPI?: boolean) => {
      let firstCountryLevel: any[] = [];
      let sohProfile: any;
      let thirdRolesLevel: any;
      if (loggedUserSOH?.length > 0) {
        //loop start
        loggedUserSOH.forEach((userSOH: any) => {
          let first = {
            value: userSOH?.countrycode, //
            label: userSOH?.geolevel0, //
          };
          firstCountryLevel.push({ ...first });
          let condIfCC = userSOH?.lastaccessprofile?.countrycode
            ? userSOH?.lastaccessprofile?.countrycode
            : loggedUserSOH[0].countrycode;
          if (condIfCC === userSOH?.countrycode) {
            sohProfile = userSOH?.sohProfilesByCountry?.[0]?.sohprofiles;
            thirdRolesLevel = sohProfile?.[0].sohroles;
          }
          // if (userSOH?.lastaccessprofile?.countrycode === userSOH?.countrycode) {
          //   sohProfile = userSOH?.sohProfilesByCountry?.[0]?.sohprofiles;
          //   thirdRolesLevel = sohProfile?.[0].sohroles;
          // }
        });
        //loop end
        if (firstCountryLevel?.length === 1 && sohProfile?.length === 1 && thirdRolesLevel?.length === 1) {
          //handle soh edit icon in header
          setLocalStorageData("isOneSOHAllLevel", true);
          const countryObj = {
            countrycode: firstCountryLevel[0].value,
          };
          const profileObj = {
            saleshiertypecode: sohProfile[0].saleshiertypecode,
          };
          const roleObj = {
            saleshierlevel: thirdRolesLevel[0]?.saleshierlevel,
            saleshierlevelname: thirdRolesLevel[0]?.saleshierlevelname,
            saleshierlevelcode: thirdRolesLevel[0]?.saleshierlevelcode,
            saleshierleveldescription: thirdRolesLevel[0]?.saleshierleveldescription,
            saleshierrolecode: thirdRolesLevel[0]?.saleshierrolecode,
            saleshierroledescription: thirdRolesLevel[0]?.saleshierroledescription,
          };
          const payload = {
            userid: loggedUserSOH?.[0]?.username,
            lastaccessprofile: {
              ...countryObj,
              ...profileObj,
              ...roleObj,
            },
          };
  
          if (!cancelAPI) {
            const { createSOHProfile } = apiURL;
            let lowestSOHLevel = thirdRolesLevel[0]?.lowestsohlevel;
            let { sohids, sohcodes } = getSOHIdsAndCode(lowestSOHLevel);
            let sohObj = {
              countrycode: firstCountryLevel[0].value,
              saleshiertypecode: sohProfile[0].saleshiertypecode,
              rolecode: thirdRolesLevel[0]?.saleshierrolecode,
              userid: loggedUserSOH?.[0]?.username,
              sohids,
            };
            getSOHLookup(sohObj);
            invokePostAuthService(createSOHProfile, payload)
              .then((response: any) => {
                if (response.status === "200") {
                  console.log("SOH Profile is configured");
                }
              })
              .catch((error: any) => {
                ErrorMsg(error);
              });
            const user = loggedUserSOH[0];
  
            const userData = {
              ...user,
              features: thirdRolesLevel[0]?.features,
              sohids,
              sohcodes,
              lastaccessprofile: payload?.lastaccessprofile,
            };
            setLocalStorageData("userData", JSON.stringify(userData));
            history.push("/dashboard");
          }
        } else if (!cancelAPI) {
          history.push("/home");
        }
      }
    };

 useEffect(() => {
    
    const urlParams = new URLSearchParams(window.location.search);
    const paramsObject = Object.keys(Object.fromEntries(urlParams.entries()))[0];
    const response = paramsObject ? JSON.parse(paramsObject) : {};

    if (Object.keys(response).length > 0) {
      // Store the token (e.g., in local storage)
      var ssoInfo = {
        accessToken: response?.accessToken,
        email: response.account.username,
        name: response.account.name,
        cwid: response.account.idTokenClaims?.["https://bayer.com/cwid"],
      };
      console.log( JSON.stringify(ssoInfo))
      setLocalStorageData("ssoInfo", JSON.stringify(ssoInfo));
      sTokenRetrive();
      
    }
  });

  const [currentLocale, setCurrentLocale] = useState(getInitialLocal());
  localStorage.setItem("UserSelectedLanguage", currentLocale);
  const handleChange = (e: any) => {
    setCurrentLocale(e.target.value);
    // storing locale in the localstorage
    localStorage.setItem("UserSelectedLanguage", e.target.value);
  };

  //localstorage
  function getInitialLocal() {
    // getting stored items
    const savedLocale = localStorage.getItem("UserSelectedLanguage");
    return savedLocale || "en";
  }

  return (
    // <React.StrictMode>
    <IntlProvider locale={currentLocale} messages={flatten(messages[currentLocale])}>
      <MsalProvider instance={msalInstance}>
        <Provider store={store}>
          <Router history={history}>
            <AppProvider>
              <Layout currentLocale={currentLocale} handleChange={handleChange}>
                <Suspense fallback={<Loader />}>
                  <ToastContainer />
                  <Switch>{setRoutes(currentLocale, handleChange)}</Switch>
                </Suspense>
              </Layout>
            </AppProvider>
          </Router>
        </Provider>
      </MsalProvider>
    </IntlProvider>
    // </React.StrictMode>
  );
};
export default App;

ReactDOM.render(<App />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
